import { CSSProperties, FunctionComponent, HTMLAttributes, useEffect, useRef, useState } from 'react';

import { TrafficLightConnected, useModifiers, useGameStateSlice, useBetSlice } from '@pp/core';

import { useMWGameGridSlice } from '../../../../store/slices/mwGameGrid/selectors';
import { MWGameStatus, MWSpecificGameStatus } from '../../../../store/slices/mwState/types';
import styles from './trafficLightCell.module.css';

export interface TrafficLightContainerConnectedProps extends HTMLAttributes<HTMLDivElement> {}

export const TrafficLightCellConnected: FunctionComponent<TrafficLightContainerConnectedProps> = ({
  className,
  ...rest
}) => {
  const [isHidden, setIsHidden] = useState(false);
  const isLoadedInActiveRound = useGameStateSlice.isLoadedInActiveRound();
  const balance = useGameStateSlice.getDeductibleBalance();
  const isLowBalance = useBetSlice.isLowBalance(balance);

  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();
  const isSpinningStatus = useGameStateSlice.getCurrentStatus() === MWSpecificGameStatus.SPINNING;
  const isWaitingForNextGameStatus = useGameStateSlice.getCurrentStatus() === MWGameStatus.WaitForNextGame;

  const containerRef = useRef<HTMLDivElement>(null);
  const bettingGridShift = useMWGameGridSlice.getDimension('bettingGridShift');
  const betSpotSize = useMWGameGridSlice.getDimension('betSpotSize');
  const bettingGridScale = useMWGameGridSlice.getDimension('bettingGridScale');

  const mods = useModifiers(styles, 'trafficLightCell', {
    collapsed: !isBetsOpenStatus || isLowBalance,
    planted: isLoadedInActiveRound,
    hidden: isHidden,
  });

  useEffect(() => {
    setIsHidden(false);
  }, [isSpinningStatus, isWaitingForNextGameStatus]);

  if (!bettingGridScale || !betSpotSize) return null;

  return (
    <div
      data-test-id={'bar'}
      className={`${styles.trafficLightCell} ${mods} ${className}`}
      style={
        {
          '--verticalShift': `${bettingGridShift}px`,
        } as CSSProperties
      }
      ref={containerRef}
      {...rest}
    >
      <TrafficLightConnected />
    </div>
  );
};
